import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';

// Layout components
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';

// Page components
import HomePage from './pages/HomePage';
// Restore this import when the public communities listing is enabled again.
// import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import SimulationPage from './pages/SimulationPage';
import SimulationsPage from './pages/SimulationsPage';
import ContactPage from './pages/ContactPage';
import AdministrationPage from './pages/AdministrationPage';
import NotFoundPage from './pages/NotFoundPage';

// Context providers
import { AppProvider } from './context/AppContext';
import { UserDataProvider } from './contexts/UserDataContext';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <AppProvider>
        <UserDataProvider>
          <div className="min-h-screen flex flex-col bg-gray-50">
            <Navbar />
            
            <main className="flex-grow">
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <Routes>
                {/* All routes are now public */}
                <Route path="/" element={<HomePage />} />
                {/* Temporarily hidden: restore ProjectsPage here when the public listing is enabled again. */}
                {/* <Route path="/comunidades-solares" element={<ProjectsPage />} /> */}
                <Route path="/comunidades-solares" element={<Navigate to="/" replace />} />
                <Route path="/comunidades-solares/:id" element={<ProjectDetailPage />} />
                <Route path="/contacto" element={<ContactPage />} />
                <Route path="/simular/:id" element={<SimulationPage />} />
                <Route path="/mis-simulaciones" element={<SimulationsPage />} />
                <Route path="/administracion" element={<AdministrationPage />} />
                
                {/* 404 route */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </motion.div>
          </main>
          
          <Footer />
        </div>
      </UserDataProvider>
    </AppProvider>
    </ErrorBoundary>
  );
}

export default App;